<template>
  <div class="card-deck mt-3">
    <div
      class="col-lg-4 col-md-6 mb-5 mb-lg-3 d-flex align-items-stretch"
      v-for="call in data"
      :key="call.id"
    >
      <div class="card card-profile shadow flex-grow-1">
        <div class="row justify-content-center">
          <div class="col-lg-3 order-lg-2">
            <div class="card-profile-image">
              <img
                :src="
                  '/img/pages/' +
                  (call.type === 'Aceleração'
                    ? 'astro_batch2024_astro'
                    : 'plane') +
                  '.png'
                "
                class="rounded-circle"
              />
            </div>
          </div>
        </div>
        <div class="card-header text-center border-0"></div>
        <div class="card-body pb-3 mt-6">
          <div class="text-center">
            <h2 class="text-center tag-title">
              <span class="tag text-warning">{{ call.name }}</span>
            </h2>

            <div class="row mt-md-3 mb-2">
              <div class="col text-center text-muted">
                Chamada de startups para
                <span class="font-weight-bold">{{ call.type }} STARS</span>
                com valor máximo investido de
                {{ formatValue(call.max_value) }} por até {{ call.max_equity }}%
                de participação.
              </div>
            </div>
            <!--
            <div class="h5 font-weight-300 mt-3" v-if="call.region">
              <i class="ni ni-pin-3 mr-1"></i>{{ call.region }}
              <i
                class="fas fa-lock ml-1"
                v-if="call.region_limited"
                :title="`Chamada limitada a startups da região (${call.region})`"
              ></i>
            </div>
            -->
          </div>
        </div>
        <div class="card-footer text-center">
          <h3 class="font-weight-light" v-if="!onlyShowButton">
            Inscrições abertas de
            <span>
              {{ formatDate(call.start_date, "L") || "..." }}
              até
              {{ formatDate(call.end_date, "L") || "..." }}
            </span>
          </h3>
          <div class="col-12 text-center" v-if="call.subscription_id">
            <div v-if="!onlyShowButton">
              <base-button
                type="success"
                :custom="true"
                :icon-only="true"
                icon="fas fa-eye"
                title="Visualizar inscrição"
                @click="handleViewSubscription(call.subscription_id)"
              ></base-button>
              <base-button
                type="info"
                :custom="true"
                :icon-only="true"
                icon="fas fa-edit"
                title="Editar inscrição"
                @click="handleEditSubscription(call.subscription_id)"
              ></base-button>
            </div>
            <div v-else>
              <base-button
                type="success"
                :custom="true"
                title="Ver inscriçAp"
                @click="handleViewSubscription(call.subscription_id)"
                >Ver inscrição</base-button
              >
            </div>
          </div>
          <div class="col-12 text-center" v-else>
            <base-button
              type="warning"
              :custom="true"
              @click="handleNewSubscription(call.id)"
              :disabled="new Date(call.end_date) < new Date()"
              >{{
                new Date(call.end_date) < new Date()
                  ? "Inscrições encerradas"
                  : "Inscreva-se"
              }}</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "startup-call-list",
  props: {
    data: {
      type: Array,
      default: () => [],
      description: "Startup calls data",
    },
    onlyShowButton: {
      type: Boolean,
      default: false,
      description: "Only show button should appears",
    },
  },
  methods: {
    handleNewSubscription(callId) {
      this.$router.push(`/startup/chamadas/${callId}/inscricao`);
    },
    handleViewSubscription(subscriptionId) {
      this.$router.push(`/startup/inscricoes/${subscriptionId}/visualizar`);
    },
    handleEditSubscription(subscriptionId) {
      this.$router.push(`/startup/inscricoes/${subscriptionId}/editar`);
    },
    truncate(text, stop = 50, clamp) {
      if (!clamp && text.slice(-1) !== ".") clamp = ".";
      return (
        text.slice(0, stop) + (stop < text.length ? clamp || "..." : clamp)
      );
    },
  },
};
</script>
<style scoped>
.card {
  margin-top: 10px;
}
.card-profile-image img {
  width: 180px;
  height: 180px;
}
</style>
